module.exports = __webpack_public_path__ + "media/country_flags/iq-e655628f.png";